import { render, staticRenderFns } from "./TransactionQuota.vue?vue&type=template&id=18b3520e&"
import script from "./TransactionQuota.vue?vue&type=script&lang=js&"
export * from "./TransactionQuota.vue?vue&type=script&lang=js&"
import style0 from "./TransactionQuota.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports